import React, { useState, useEffect } from 'react';
import Modal from '../../Modal';
import GradientLogo from '../../../../public/icons/GradientLogo';
import useUserDataStore from '../../../store/userDataStore';
import CSS from './LogIn.module.css';

export default function LogInPromptPopUp() {
  const [openModal, setOpenModal] = useState(false);
  const { userData } = useUserDataStore();

  // Check if user is logged in by verifying if userData has an id
  const isLoggedIn = userData && userData.id;

  // Pop up once every session
  useEffect(() => {
    const hasSeenModal = sessionStorage.getItem('hasSeenLogInPrompt');

    // Only show popup if user hasn't seen it AND user is NOT logged in
    if (!hasSeenModal && !isLoggedIn) {
      sessionStorage.setItem('hasSeenLogInPrompt', true);
      setTimeout(() => {
        // Check if user is on the login page at the moment popup is about to show
        const isOnLoginPage = window.location.pathname === '/swapandtop/login';

        // Only show popup if user is NOT on login page
        if (!isOnLoginPage) {
          setOpenModal(true);
        }
      }, 5000);
    }
  }, [isLoggedIn]);

  // Remove scroll on pop up
  useEffect(() => {
    openModal
      ? (document.body.style.overflow = 'hidden')
      : (document.body.style.overflow = 'unset');
  }, [openModal]);

  // Open/close Modal
  const toggleModal = (e) => {
    e.preventDefault();
    setOpenModal(!openModal);
  };

  return (
    <Modal open={openModal} toggleModal={toggleModal} overlayType='unclickable'>
      <div className={`modal-content ${CSS.promptModalContent}`}>
        {/* Close button */}
        <button
          onClick={toggleModal}
          className={CSS.promptCloseButton}
          aria-label='Close'>
          <div className={CSS.promptCloseIconWrapper}>
            <div
              className={`${CSS.promptCloseIconBar} ${CSS.promptCloseIconBar1}`}
            />
            <div
              className={`${CSS.promptCloseIconBar} ${CSS.promptCloseIconBar2}`}
            />
          </div>
        </button>

        <GradientLogo svgClass='delete-acc-icon' pathClass='gradient-bg-icon' />
        <h2 className='modal-heading' style={{ marginTop: "10px" }}>👋😄 Hey there!</h2>
        <h2 className='modal-heading'>Thanks for visiting Swap & Top!</h2>
        <p className={`modal-paragraph ${CSS.promptMessage}`}>
          Create a <strong>free account</strong> to:
          <br />
          • Post items for free
          <br />
          • Follow your favourite posts
          <br />
          • Get the best overall experience
        </p>
        <a
          href='/swapandtop/login'
          className={`modal-btn gradient-bg ${CSS.promptLoginButton}`}>
          Create Account / Log in
        </a>
        <br />
        <p className={CSS.lastPromptMessage}>or just browsing?</p>
        <span onClick={toggleModal} className={CSS.promptGuestButton}>
          Continue as guest
        </span>
      </div>
    </Modal>
  );
}
